export enum GenerationStatus {
  Unknown = -1,
  None = 0,
  Pending = 1,
  Running = 2,
  Completed = 3,
  CompletedWithErrors = 4,
  Failed = 5,
  Cancelled = 6,
  RunningUpscale = 7,
}

export const GENERATION_STATUSES = [GenerationStatus.Running, GenerationStatus.Pending] as const

export const statusToLabelMap: Record<GenerationStatus, string> = {
  [GenerationStatus.Unknown]: 'Unknown',
  [GenerationStatus.None]: 'None',
  [GenerationStatus.Pending]: 'Pending',
  [GenerationStatus.Running]: 'Running',
  [GenerationStatus.Completed]: 'Completed',
  [GenerationStatus.CompletedWithErrors]: 'Errors',
  [GenerationStatus.Failed]: 'Failed',
  [GenerationStatus.Cancelled]: 'Cancelled',
  [GenerationStatus.RunningUpscale]: 'Upscaling',
}
